import { CalculationOrvForm } from '../model/business/calculation/CalculationForm';
import { BehaviorSubject } from 'rxjs';

interface ApplicationFormValues {
  insured?: {
    initials: string;
    middleName: string;
    surname: string;
  };
  insured2?: {
    initials: string;
    middleName: string;
    surname: string;
  };
}

export class SessionOrvService {
  applicationFormValues = new BehaviorSubject<ApplicationFormValues>({});
  private calculationFormValues = new CalculationOrvForm();

  setCalculationFormValues(calculationFormValues: CalculationOrvForm): void {
    this.calculationFormValues = calculationFormValues;
  }

  getCalculationFormValues(): CalculationOrvForm {
    return this.calculationFormValues;
  }

  setApplicationFormValues(applicationFormValues: any): void {
    this.applicationFormValues.next(applicationFormValues);
  }

  getApplicationFormValues(): ApplicationFormValues {
    return this.applicationFormValues.value;
  }

  clearCalculationFormValues(): void {
    this.calculationFormValues = new CalculationOrvForm();
  }

  clearApplicationFormValues(): void {
    this.applicationFormValues.next({});
  }

  getInsuredName(): string {
    const {
      initials,
      middleName,
      surname,
    } = this.applicationFormValues.value.insured || {};

    return `${initials} ${middleName || ''} ${surname}`;
  }

  getInsured2Name(): string {
    const {
      initials,
      middleName = '',
      surname,
    } = this.applicationFormValues.value.insured2 || {};

    return `${initials} ${middleName || ''} ${surname}`;
  }
}
